import { Directive, ElementRef, HostListener, inject, input, output } from '@angular/core';

@Directive({
  selector: '[avsLoadMore]',
})
export class LoadMoreDirective {
  threshold = input(100, { alias: 'avsLoadMore' });
  loadMore = output<void>();

  private el = inject<ElementRef<HTMLElement>>(ElementRef);

  @HostListener('scroll')
  protected onScroll() {
    const element = this.el.nativeElement;

    if (element.scrollHeight <= element.clientHeight) {
      return;
    }

    const distanceFromBottom = element.scrollHeight - element.scrollTop - element.clientHeight;

    if (distanceFromBottom <= this.threshold()) {
      this.loadMore.emit();
    }
  }
}
